const SPLIT_LOWER_UPPER_RE = /([\p{Ll}\d])(\p{Lu})/gu;
const SPLIT_UPPER_UPPER_RE = /(\p{Lu})([\p{Lu}][\p{Ll}])/gu;
const STRIP_RE = /[^\p{L}\d]+/giu;
const SPLIT_REPLACE = "$1\0$2";

function split(value: string): string[] {
  let result = value
    .trim()
    .replace(SPLIT_LOWER_UPPER_RE, SPLIT_REPLACE)
    .replace(SPLIT_UPPER_UPPER_RE, SPLIT_REPLACE)
    .replace(STRIP_RE, "\0");
  let start = 0;
  let end = result.length;
  while (result.charAt(start) === "\0") start++;
  if (start === end) return [];
  while (result.charAt(end - 1) === "\0") end--;
  return result.slice(start, end).split(/\0/g);
}

function capitalize(word: string): string {
  if (!word) return word;
  return word[0].toUpperCase() + word.slice(1).toLowerCase();
}

export function camelCase(input: string): string {
  return split(input)
    .map((word, i) => (i === 0 ? word.toLowerCase() : capitalize(word)))
    .join("");
}

export function capitalCase(input: string): string {
  return split(input).map(capitalize).join(" ");
}

export function constantCase(input: string): string {
  return split(input)
    .map((w) => w.toUpperCase())
    .join("_");
}

export function kebabCase(input: string): string {
  return split(input)
    .map((w) => w.toLowerCase())
    .join("-");
}

export function sentenceCase(input: string): string {
  return split(input)
    .map((word, i) => (i === 0 ? capitalize(word) : word.toLowerCase()))
    .join(" ");
}

export function snakeCase(input: string): string {
  return split(input)
    .map((w) => w.toLowerCase())
    .join("_");
}
